import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import {
  fetchDataEngine,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
  employeeLeaveBalances,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import { tokens } from "../../../theme";
import { useTheme } from "@emotion/react";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import { fetchJson } from "../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = HRService.uri;

const LeaveApplicationsTable = () => {
  const actions = {
    entity: "My Leave Applications",
    isSubRight: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
      inputObjectName: "createCaseDynamic",
      InputObject: "newCase",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },
    AssignTask: {
      key: "ASSIGN_TASK",
      button_name: "Assign Task",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewRelievers: {
      key: "MARK_TASK_DONE",
      button_name: "View Relievers",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    dataObject: {
      objectName: "leaveApplications",
      inputObjectName: "applicationsApprovals",
      parameters: '',
    },

    showStatus: true,
  };
  const [data, setData] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  useEffect(() => {
    let isMounted = true;

    async function fetchLeaveBalances() {
      try {
        const response = await fetchJson({
          objectName:"employeeLeaveBalances", 
          baseUrl: base_url
      });
        if (response) {
          setData(JSON.parse(response.results) || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchLeaveBalances();

    return () => {
      isMounted = false;
    };
  }, []);
  const card = (
    <>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Your Annual Leave Balances
        </Typography>

        {/* <Typography variant="h5" component="div">
                Leave
              </Typography> */}
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {data.balance !== null || data.Balance !== 0
            ? data.Balance
            : "No balance available"}
        </Typography>

        {/* <Typography variant="body2">
          well meaning and kindly.
          <br />
          {'"a benevolent smile"'}
        </Typography> */}
      </CardContent>
    </>
  );

  return (
    <Box m="2px">
      <>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Card
            variant="outlined"
            sx={{
              minWidth: 275,
              backgroundColor: colors.primary[400],
            }}
          >
            {card}
          </Card>
        </Box>
        <DynamicTableForJson
          title="Leave Applications"
          subtitle="View all Leave applications, create or update a leave"
          columns={LeaveApplicationsColumns}
          FormComponent={LeaveApplicationForm}
          // query={leaveApplicationsByUser}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
};

export default LeaveApplicationsTable;
